import { createStyles, makeStyles, Theme } from '@material-ui/core';


export const MediaListStyles = makeStyles(({ breakpoints }: Theme) => createStyles({
  root: {
    [breakpoints.down(750)]: {
      justifyContent: 'center',
    },
  },
  mediaContainer: {
    minWidth: 250,
    display: 'flex',
  },
  sortSelect: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-start',
  },
  label: {
    padding: 10,
    fontSize: 16,
    color: '#263245',
    fontFamily: 'Roboto',
  },
  selectMenu: {
    paddingRight: 14,
    height: 37,
    width: 270,
    color: '#4D595D',
    '& .MuiSelect-selectMenu': {
      '&:focus': {
        backgroundColor: '#fff',
      },
    },
  },
  checkIcon: {
    color: '#00A8BE',
    fontSize: 14,
    width: 15,
    height: 32,
    marginRight: 7,
  },

  selectedMenuItem: {
    backgroundColor: '#fff !important',
  },
  selectContainer: {
    [breakpoints.down('xs')]: {
      justifyContent: 'center',
      width: 'min-content',
      margin: '10px 0',
    },
  },
  mediaBarContainer: {
    [breakpoints.down('xs')]: {
      justifyContent: 'center',
    },
  },
  mediaSearchContainer: {
    [breakpoints.down('xs')]: {
      width: '266px',
    },
  },

}), { name: 'MediaList' });
